export default (
  state = {
    filled: {
      Name: {
        filled: false,
        error: false
      },
      Email: {
        filled: false,
        error: false
      }
    }
  },
  action
) => {
  switch (action.type) {
    case 'VALIDATION_NAME_SUCCESS':
      return { ...state, filled: { Name: { filled: true, error: null } } }
    case 'VALIDATION_NAME_FAIL':
      return { ...state, filled: { Name: { filled: false, error: true } } }
    case 'VALIDATION_MAIL_SUCCESS':
      return { ...state, filled: { Mail: { filled: true, error: false } } }
    case 'VALIDATION_MAIL_FAIL':
      return { ...state, filled: { Mail: { filled: false, error: true } } }
    case 'SEND_MAIL':
      return { ...state, isloading: true, filled: false }
    case 'SEND_MAIL_SUCCESS':
      return {
        ...state,
        success: { ...action.payload.data }
      }
    case 'SEND_MAIL_FAIL':
      return {
        ...state,
        success: {},
        error: action.error
      }
    default:
      return { ...state }
  }
}



// WEBPACK FOOTER //
// ./src/Catalog/Product/ProductDetail/RedemptionSection/Unvailable/reducer.js